var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.551,
    height: 49.5,
    viewBox: "0 0 63.551 49.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_3_User",
    "data-name": "Iconly/Light/3 User",
    transform: "translate(0.776 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3_User",
    "data-name": "3 User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M0,18.022A8.9,8.9,0,0,0,8.773,9.011,8.9,8.9,0,0,0,0,0",
    transform: "translate(48.087 2.925)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M0,0A27.81,27.81,0,0,1,4.3.641c1.967.4,4.334,1.224,5.176,3.038a4.4,4.4,0,0,1,0,3.678C8.637,9.17,6.268,10,4.3,10.412",
    transform: "translate(52.12 30.74)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5",
    "data-name": "Stroke 5",
    d: "M8.773,18.022A8.9,8.9,0,0,1,0,9.011,8.9,8.9,0,0,1,8.773,0",
    transform: "translate(5.14 2.925)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_7",
    "data-name": "Stroke 7",
    d: "M9.879,0a27.81,27.81,0,0,0-4.3.641c-1.967.4-4.334,1.224-5.174,3.038a4.376,4.376,0,0,0,0,3.678C1.242,9.17,3.611,10,5.579,10.412",
    transform: "translate(0 30.74)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_9",
    "data-name": "Stroke 9",
    d: "M18.2,0c9.815,0,18.2,1.526,18.2,7.633s-8.33,7.687-18.2,7.687C8.382,15.32,0,13.794,0,7.687S8.33,0,18.2,0Z",
    transform: "translate(12.785 32.68)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_11",
    "data-name": "Stroke 11",
    d: "M11.663,23.969A11.786,11.786,0,0,1,0,11.983,11.786,11.786,0,0,1,11.663,0,11.786,11.786,0,0,1,23.327,11.983,11.786,11.786,0,0,1,11.663,23.969Z",
    transform: "translate(19.322)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingOrder);
export default __webpack_public_path__ + "static/media/pending_order.5747bc4e534131e436e0e69efaa21704.svg";
export { ForwardRef as ReactComponent };